module.exports = __webpack_public_path__ + "static/og-7e39e3a95a5fc8db3633c538ae1e75a3.png";